'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @primitive Tooltip
 * ROLE: tooltip | ARIA: aria-describedby wired by Radix via TooltipContent id
 * KEYBOARD: shows on focus-visible; ESC closes; Tab/Shift+Tab navigate away
 * FOCUS: does not trap focus; trigger is the focusable element
 * LIVE-REGION: none (tooltip content is SR-exposed via aria-describedby)
 * PRM: animation disabled; opacity instant
 * TOUCH: does NOT show on touch-only devices — content must also be conveyed inline
 * FORCED-COLORS: content border = ButtonText
 * RTL: side/align flips via Radix; direction-agnostic
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/patterns/tooltip/
 * SUBSTRATE: @radix-ui/react-tooltip
 */
import * as RadixTooltip from '@radix-ui/react-tooltip';
import styles from './Tooltip.module.css';
export function Tooltip({ content, children, side = 'top', align = 'center', sideOffset = 6, delayDuration = 400, }) {
    return (_jsx(RadixTooltip.Provider, { delayDuration: delayDuration, children: _jsxs(RadixTooltip.Root, { children: [_jsx(RadixTooltip.Trigger, { asChild: true, children: children }), _jsx(RadixTooltip.Portal, { children: _jsx(RadixTooltip.Content, { className: styles.content, side: side, align: align, sideOffset: sideOffset, children: content }) })] }) }));
}
//# sourceMappingURL=Tooltip.js.map